import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/dokumentasi-kelainan-kulit", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/dokumentasi-kelainan-kulit/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/dokumentasi-kelainan-kulit`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function timeline(pasien_rm: string | number) {
  const response = await http
    .getData(`/dokumentasi-kelainan-kulit/timeline/${pasien_rm}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/dokumentasi-kelainan-kulit/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http
    .putData(`/dokumentasi-kelainan-kulit/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/dokumentasi-kelainan-kulit/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

async function uploadFoto(
  id: number,
  file: File,
  meta: { view?: string; catatan?: string; taken_at?: string }
) {
  try {
    const form = new FormData();
    form.append("file", file);
    if (meta.view) form.append("view", meta.view);
    if (meta.catatan) form.append("catatan", meta.catatan);
    if (meta.taken_at) form.append("taken_at", meta.taken_at);
    const res = await http.postData(`/dokumentasi-kelainan-kulit/${id}/foto`, form);
    return res?.data?.data ?? null;
  } catch (e) {
    ErrorAlert.showErrorAlert(e);
    return null;
  }
}

async function deleteFoto(id: number, fotoId: number): Promise<boolean> {
  try {
    await http.deleteData(`/dokumentasi-kelainan-kulit/${id}/foto/${fotoId}`);
    return true;
  } catch (e) {
    ErrorAlert.showErrorAlert(e);
    return false;
  }
}

function print(id) {
  window.open(`${http.getAPI()}/dokumentasi-kelainan-kulit/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  timeline,
  find,
  signDokter,
  destroy,
  uploadFoto,
  deleteFoto,
  print
};
